import React, { Component } from 'react';
import { BrowserRouter, Route, Link, Redirect } from "react-router-dom";

import SearchBox from './components/SearchBox';
import Frontpage from './components/Frontpage';
import SearchResultsList from './components/SearchResultsList';

import CollapsibleCard from './components/CollapsibleCard';
import TermViewContainer from './components/TermViewContainer';
import StickyWatcher from './components/StickyWatcher';
import OrdasofnList from './components/OrdasofnList';
import ContactFormWrapper from './components/ContactFormWrapper';
import GoogleAnalytics from './components/GoogleAnalytics';
import SiteFooter from './components/SiteFooter';

import config from "./config";

import logo from './img/logo-single.png';

class App extends Component {
	constructor(props) {
		super(props);

		this.menuButtonClickHandler = this.menuButtonClickHandler.bind(this);

		this.fetchHelperData();

		this.state = {
			searchParams: {},
			menuOpen: false
		};
	}

	componentDidMount() {
		this.refs.router.history.listen(function() {
			this.setState({
				menuOpen: false
			});
		}.bind(this));

		document.addEventListener('mousedown', function(event) {
			if (!this.state.menuOpen) {
				return;
			}

			if (this.refs.menuButton.contains(event.target)) {
				event.stopPropagation();

				return;
			}

			if (this.refs.menuContent && !this.refs.menuContent.contains(event.target)) {
				this.setState({
					menuOpen: false
				})
			}
		}.bind(this));
	}

	menuButtonClickHandler(event) {
		event.stopPropagation();
		if (!this.state.menuOpen) {
			this.refs.menuContent.scrollTop = 0;
		}

		this.setState({
			menuOpen: !this.state.menuOpen
		});
	}

	fetchHelperData() {
		window.ordabankiData = {};

		// Sæki nöfn og kóða allra tungumála
		fetch(config.apiRoot+'/api/languages?limit=1000')
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				var languages = {};

				for (let lang of json.results) {
					languages[lang.fklanguage] = lang.name;
				}

				// Geymi gögnin í global ordabankiData hlut
				window.ordabankiData['lang'] = languages;

				this.setState({
					languages: languages
				})
			}.bind(this));

		// Sæki nöfn og kóða allra orðabóka
		fetch(config.apiRoot+'/api/dictionaries?limit=1000')
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				var dictionaries = {};

				for (let dictionary of json.results) {
					dictionaries[dictionary.fkdictionary] = dictionary.name;
				}

				// Geymi gögnin í global ordabankiData hlut
				window.ordabankiData['dictionaries'] =dictionaries;

				this.setState({
					dictionaries: dictionaries
				})
			}.bind(this));
	}

	render() {
		return (
			<BrowserRouter ref="router">
				<React.Fragment>
					<div className="header">

						<div className="container">

							<div className="logo-wrapper">
								<div className="logo">
									<img src={logo} className="mr-4" />
								</div>
								
								<div className="text">
									<div>Íðorðabankinn</div>
									<div className="smaller">Árnastofnun</div>
								</div>

							</div>

						</div>
						{/*
						<div className="anniversary">
							<span>25 <small>ára</small></span>
						</div>
						*/}

					</div>

					<StickyWatcher tagName="div"
						className="search-container"
						stickyClassName="sticky"
						onStick={function() {
							this.setState({
								searchFormSticky: true
							});
						}.bind(this)}
						onUnstick={function() {
							this.setState({
								searchFormSticky: false
							});
						}.bind(this)}
					>

						<div className="container">
							<button className="btn-menu" ref="menuButton" onClick={this.menuButtonClickHandler}>
								<div className="hamburger-icon black">
									<div className="icon-middle" />
									<div className="icon-before-after" />
								</div>
							</button>

							<SearchBox searchOrdabok={this.state.searchParams.ordabok || ''} searchString={this.state.searchParams.searchString || ''} />

						</div>

					</StickyWatcher>

					<div className={'container'+(this.state.searchFormSticky ? ' searchform-sticky' : '')}>

						<Route path="/" component={Frontpage} exact={true} />
						<Route path="/leit/ordabok/:ordabok" render={(routeProps) => (
							<Redirect to={'/leit//ordabok/'+routeProps.match.params.ordabok} />
						)} />
						<Route exact strict path="(/leit/)?:searchString*(/ordabok/)?:ordabok*(/order/)?:order*(/page/)?:page*" render={(routeProps) => (
							<SearchResultsList onSearch={searchParams => this.setState({searchParams: searchParams})} {...routeProps} />
						)} />
						<Route exact strict path="/faersla/:entry_id" render={(routeProps) => (
							<React.Fragment>
								<TermViewContainer {...routeProps} />
							</React.Fragment>
						)} />
						<Route exact strict path="/hafa-samband/:ordabok" render={(routeProps) => (
							<ContactFormWrapper {...routeProps} />
						)} />

					</div>

					<div className={'app-menu'+(this.state.menuOpen ? ' open' : '')} ref="menuContent">
						<div className="container">

							<button className="btn btn-link float-right" onClick={
								function() {
									this.setState({
										menuOpen: false
									});
								}.bind(this)}>
								<div className="hamburger-icon black open">
									<div className="icon-middle" />
									<div className="icon-before-after" />
								</div>
							</button>

							<h5 className="mb-4 pt-2">Íðorðabankinn</h5>

							<p>Íðorðabanki Stofnunar Árna Magnússonar í íslenskum fræðum veitir aðgang að íslenskum þýðingum á erlendum íðorðum og hugtakaskilgreiningum íðorða á íslensku og fleiri tungumálum.</p>

							<CollapsibleCard title="Orðasöfn" mobileMenu={false} alwaysOpen={true} className="gray mb-6 tight-card">
								<OrdasofnList className=" " />
							</CollapsibleCard>

						</div>
					</div>

					<SiteFooter />

					<GoogleAnalytics />

				</React.Fragment>
			</BrowserRouter>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js